/**
 * Shared "correct vs incorrect" bar pair for the teacher's reveal view.
 * Used by any question type whose tally carries correct/incorrect counts:
 * checkbox_sim, order and match report them as { kind: 'correctness' },
 * while expr and numeric carry them alongside their own richer breakdown
 * (see QuestionSession.getTally on the server).
 */
export default function CorrectnessTally({ tally }) {
  if (!tally || typeof tally.correct !== 'number') return null;
  const total = tally.correct + tally.incorrect || 1;

  return (
    <div className="tally-bars">
      <div className="tally-bar-row is-correct">
        <div className="tally-bar-label">
          <span className="tally-bullet" style={{ background: 'var(--color-success)' }} />
          <span className="tally-text">ถูกต้อง</span>
        </div>
        <div className="tally-bar-track">
          <div className="tally-bar-fill" style={{ width: `${(tally.correct / total) * 100}%`, background: 'var(--color-success)' }} />
        </div>
        <span className="tally-bar-count">{tally.correct} คน</span>
      </div>
      <div className="tally-bar-row">
        <div className="tally-bar-label">
          <span className="tally-bullet" style={{ background: 'var(--color-text-dim)' }} />
          <span className="tally-text">ยังไม่ถูก</span>
        </div>
        <div className="tally-bar-track">
          <div className="tally-bar-fill" style={{ width: `${(tally.incorrect / total) * 100}%`, background: 'var(--color-text-dim)' }} />
        </div>
        <span className="tally-bar-count">{tally.incorrect} คน</span>
      </div>
    </div>
  );
}
